import {useEffect, type ComponentType} from 'react';
import {DiferpanHeader} from '@components';
import {buildBreadcrumbItems, DiferpanFooter} from 'diferpan-common-web'
import { useAppMessage } from '@providers'
import {useKeycloak} from '@react-keycloak/web';
import {Navigate} from 'react-router-dom';
import {RoutesFields} from "@constants";
import {useGlobalUser} from '@hooks'
import {Breadcrumb} from "antd";

const FALLBACK_ROUTE = RoutesFields.HOME;


interface ConteudoRotaProps {
    component: ComponentType<{ page?: string; className?: string }>;
    headerTitle?: string;
    path?: string;
    page?: string;
}

function ConteudoRota({ component: PropComponent, headerTitle, path, page }: ConteudoRotaProps) {
    const breadcrumbItems = buildBreadcrumbItems({
        RoutesFields,
        path
    })
    return (
        <>
            <div className='container-page-style'>
                {headerTitle && <DiferpanHeader title={headerTitle}/>}
                <Breadcrumb
                    items={breadcrumbItems}
                    className={'routewrapper-breadcrump-class'}
                />
                <div className={'body-page-style'}>
                    <PropComponent page={page} className='body-route-class'/>
                </div>
                <DiferpanFooter/>
            </div>
        </>
    )
}


interface RouteWrapperProps extends ConteudoRotaProps {
    permissions: readonly string[];
    isPublic?: boolean;
}

const extrairCodigo = (valor: unknown): number | null => {
    if (typeof valor === 'number') return Number.isFinite(valor) ? valor : null;
    if (typeof valor !== 'string' || valor.trim() === '') return null;
    const convertido = Number(valor);
    return Number.isFinite(convertido) ? convertido : null;
};

const extrairBooleano = (valor: unknown): boolean | null => (typeof valor === 'boolean' ? valor : null);

export function RouteWrapper({
                                 component:
                                     PropComponent,
                                 permissions,
                                 headerTitle,
                                 isPublic,
                                 path,
                                 page,
                             }: RouteWrapperProps) {
    const [, setUser] = useGlobalUser();
    const {keycloak} = useKeycloak();
    const tokenParsed = keycloak.tokenParsed;
    const userRoles: string[] = keycloak.realmAccess?.roles || [];
    const chaveDeRoles = userRoles.join(',');


    useEffect(() => {
        if (tokenParsed && userRoles.length > 0) {
            setUser({
                name: tokenParsed.given_name || null,
                email: tokenParsed.email || null,
                code: extrairCodigo(tokenParsed.code),
                isFornecedor: extrairBooleano(tokenParsed.isFornecedor),
                userRoles: userRoles
            });
        }
    }, [tokenParsed, chaveDeRoles, setUser]);

    const hasPermission = userRoles && permissions.some(role => userRoles.includes(role));
    const message = useAppMessage();


    if (isPublic || (keycloak.authenticated && hasPermission)) {
        return <ConteudoRota component={PropComponent} headerTitle={headerTitle} path={path} page={page}/>;

    } else {
        message.error(`Você não possui permissão para acessar ${path}`);
        return <Navigate to={FALLBACK_ROUTE.PATH} replace/>;
    }
}
